// Shared world configuration and TerrainType enum

export const WorldConfig = Object.freeze({
  CHUNK_SIZE: 100,
  SEED: 'isekai',
  VERSION: 1,
});

// TerrainType is shared and numeric to allow compact storage in arrays
export const TerrainType = Object.freeze({
  deepwater: 0,
  water: 1,
  shallowwater: 2,
  beach: 3,
  grass: 4,
  forest: 5,
  lowHills: 6,
  highHills: 7,
  mountains: 8,
});

export const TerrainTypeNames = Object.freeze(
  Object.entries(TerrainType)
    .sort((a, b) => a[1] - b[1])
    .map(([name]) => name)
);

export function isValidTerrainType(v) {
  return Number.isInteger(v) && v >= 0 && v <= TerrainType.mountains;
}
